import { withFieldHint } from "@/src/components/HighOrderComponents";
import { SelectCounterField } from "@/src/components/Fields/SelectCounterField";

const UserSelectCounterFieldWithHint = withFieldHint(SelectCounterField);

export function UserSelect(props: any) {
  const hints = props?.hint?.hintsList;
  return <UserSelectCounterFieldWithHint {...props} hints={hints} />;
}
